module.exports = "<div class=\"as-copy code-box\">\n    <div class=\"copy\">\n        <button class=\"button\" data-clipboard-action=\"copy\" data-clipboard-target=\"#{{$ctrl.id}}\"\n                ng-hide=\"$ctrl.hidecopybutton\"\n                ngclipboard popover-is-open=\"isOpen\" uib-popover=\"{{popoverText}}\" ng-click=\"$ctrl.copy()\">Copy</button>\n    </div>\n    <pre id=\"{{$ctrl.id}}\" class=\"prettyprint lang-html\">\n        <code ng-class=\"{failedload:$ctrl.hidecopybutton}\">{{$ctrl.text}}</code>\n    </pre>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./modules/shared/asCopy/asCopy.component.html
// module id = 671
// module chunks = 0